module.exports = function() {
	return new Worker(__webpack_public_path__ + "6ed86c45cf6fc2c856c7.worker.js");
};


//////////////////
// WEBPACK FOOTER
// ./~/worker-loader!./src/deckard/workers/DataImporter.ts
// module id = 145
// module chunks = 0